export default class MainVisual {

  /**
   * コンストラクタ
   */
  constructor() {

    //レイアウト用の設定
    this.LAYOUT_CELL_NUM = [5, 5, 4, 5, 3, 4, 5, 5];
    this.imgIndex = -1;
    this.imgNum = 0;

    //ロゴ画像データの数
    this.LOGO_IMAGES_NUM = 12;
    // console.log("path:" + path);

    //参照
    this.$mainSlide = $(".main-slide");

    //画像読み込み準備
    this.imagesData = this.$mainSlide.data("images");

    if (!this.imagesData) {
      return;
    }

    this.images = this.imagesData.split(",");
    this.images.pop();
    for(let i = this.images.length - 1; i > 0; i--){
        var r = Math.floor(Math.random() * (i + 1));
        var tmp = this.images[i];
        this.images[i] = this.images[r];
        this.images[r] = tmp;
    }
    this.imgNum = this.images.length;
    this.imgCount = this.images.length + this.LOGO_IMAGES_NUM;

    //メディアファイル読み込み
    for(let i=0; i<this.images.length; i++)
    {
      var img = new Image();
      img.onload = this.onImgLoaded.bind(this);
      img.src = this.images[i];
    }

    //ロゴデータ読み込み
    for(let ii=0; ii<this.LOGO_IMAGES_NUM; ii++)
    {
      var logoImgIndex = ii + 1;
      var logoImgIndexStr = (logoImgIndex < 10)?"0"+logoImgIndex:logoImgIndex.toString();
      var img = new Image();
      img.onload = this.onImgLoaded.bind(this);
      img.src = path + "/assets/images/top-slide/slide_logo"+logoImgIndexStr+".png";
    }
  }

  /**
   * 画像読み込み完了
   */
  onImgLoaded()
  {
    this.imgCount --;
    // console.log("this.imgCount:" + this.imgCount);
    if(this.imgCount <= 0)
    {
      this.nextSlide();
    }
  }

  /**
   * 次のスライド
   */
  nextSlide()
  {
    //一旦空っぽにする
    this.$mainSlide.empty();

    //レイアウトパターンをランダムで選択
    let layoutIndex = Math.floor(Math.random()*8);
    // layoutIndex = 7;

    //セルの数
    let cellNum = this.LAYOUT_CELL_NUM[layoutIndex];

    //DOMの生成
    const $ul = $("<ul>");
    $ul.addClass("layout" + (layoutIndex + 1));
    for(let i=0; i<cellNum; i++)
    {
      $ul.append("<li><span></span></li>");
    }
    this.$mainSlide.append($ul);

    //ロゴ表示用配列
    var logoClassArray = ["", "", "", "", ""];
    if(Math.random()*100 < 50)
    {
      switch (layoutIndex) {
        case 0:
          let rnd = Math.random()*100;
          if(rnd < 25)
          {
            logoClassArray = ["", "logo01", "", "", ""];
          }
          else if(rnd < 50)
          {
            logoClassArray = ["", "", "", "logo03", "logo02"];
          }
          else if(rnd < 75)
          {
            logoClassArray = ["", "", "", "logo07", "logo08"];
          }
          else
          {
            logoClassArray = ["logo05", "", "", "", ""];
          }
          break;
        case 2:
          logoClassArray = ["", "logo01", "logo04", "logo05", ""];
          break;
        case 3:
          let rnd2 = Math.random()*100;
          if(rnd2 < 50)
          {
            logoClassArray = ["logo09", "", "", "", ""];
          }
          else
          {
            logoClassArray = ["", "", "", "logo02", "logo10"];
          }
          break;
        case 4:
          let rnd3 = Math.random()*100;
          if(rnd3 < 33)
          {
            logoClassArray = ["", "logo06", "", "", ""];
          }
          else if(rnd3 < 66)
          {
            logoClassArray = ["logo08", "", "", "", ""];
          }
          else
          {
            logoClassArray = ["", "logo11", "logo02", "", ""];
          }
          break;
        case 5:
          logoClassArray = ["logo13", "", "", "", ""];
          break;
        case 6:
          logoClassArray = ["", "", "", "", "logo13"];
          break;
        case 7:
          logoClassArray = ["logo03", "", "logo12", "logo05", "logo13"];
          break;
      }
    }

    //各セルの設定
    const holder = this;
    this.$mainSlide.find("li >span").each(function(index){

      //参照
      const $span = $(this);

      //背景画像設定
      holder.imgIndex ++;
      if(holder.imgIndex >= holder.imgNum) holder.imgIndex = 0;
      const logoClass = logoClassArray[index];
      if(logoClass == "")
      {
        $span.css('background-image', 'url('+holder.images[holder.imgIndex]+')');
      }
      else
      {
        $span.parent().addClass(logoClass);
      }
      $span.addClass(holder.getRandomDirection());
      setTimeout(function(){
        $span.removeClass();
        $span.addClass("animation");
      }, 100);
      setTimeout(function(){
        $span.addClass(holder.getRandomDirection());
      }, 1900);
    });

    //次のスライドへ
    setTimeout(()=>{
      this.nextSlide();
    }, 2700);
  }

  /**
   * ランダムで方向クラスを取得
   */
  getRandomDirection()
  {
    const dirIndex = Math.floor(Math.random()*4);
    let dir = "";
    switch (dirIndex) {
      case 0:
        dir = "left";
        break;
      case 1:
        dir = "top";
        break;
      case 2:
        dir = "right";
        break;
      case 3:
        dir = "bottom";
        break;
    }

    return dir;
  }

}
